/* 416bb0f2a149c0c5a07660212a3dcc2aacc2d139
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductDetailCountdownFlashsaleQueryVariables = Types.Exact<{
  productId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ProductDetailCountdownFlashsaleQuery = { __typename?: 'Query', flashSaleProduct?: { __typename?: 'FlashSaleProduct', product?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, hot_product?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, user_guide?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, hot_product?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, user_guide?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'VirtualProduct' } | null, sales_data?: { __typename?: 'FlashSaleProductData', created_at?: string | null, date_from?: string | null, date_to?: string | null, deal_id?: number | null, deal_price?: number | null, deal_qty?: number | null, deal_value?: number | null, flashsale_id?: number | null, limit_per_order?: number | null, product_id?: number | null, product_name?: string | null, product_sku?: string | null, sale_qty?: number | null, status?: number | null, store_ids?: number | null, updated_at?: string | null } | null } | null };

export type ConfigurableProductBasicFragment = { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, hot_product?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, user_guide?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null };

export type SimpleProductBasicFragment = { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, hot_product?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, user_guide?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null };

export const ConfigurableProductBasicFragmentDoc = gql`
    fragment ConfigurableProductBasic on ConfigurableProduct {
  id
  sku
  name
  url_key
  url_suffix
  stock_status
  brand
  ratings_count
  ratings_summary
  has_gift
  hot_product
  new_product
  news_from_date
  news_to_date
  meta_title
  meta_description
  meta_keyword
  canonical_url
  user_guide
  categories {
    name
    level
    priority
  }
}
    `;
export const SimpleProductBasicFragmentDoc = gql`
    fragment SimpleProductBasic on SimpleProduct {
  id
  sku
  name
  url_key
  url_suffix
  stock_status
  brand
  ratings_count
  ratings_summary
  has_gift
  hot_product
  new_product
  news_from_date
  news_to_date
  meta_title
  meta_description
  meta_keyword
  canonical_url
  user_guide
  categories {
    name
    level
    priority
  }
}
    `;
export const ProductDetailCountdownFlashsaleDocument = gql`
    query ProductDetailCountdownFlashsale($productId: Int) {
  flashSaleProduct(product_id: $productId) {
    product {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
      }
    }
    sales_data {
      created_at
      date_from
      date_to
      deal_id
      deal_price
      deal_qty
      deal_value
      flashsale_id
      limit_per_order
      product_id
      product_name
      product_sku
      sale_qty
      status
      store_ids
      updated_at
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${SimpleProductBasicFragmentDoc}`;

/**
 * __useProductDetailCountdownFlashsaleQuery__
 *
 * To run a query within a React component, call `useProductDetailCountdownFlashsaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailCountdownFlashsaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailCountdownFlashsaleQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductDetailCountdownFlashsaleQuery(baseOptions?: Apollo.QueryHookOptions<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>(ProductDetailCountdownFlashsaleDocument, options);
      }
export function useProductDetailCountdownFlashsaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>(ProductDetailCountdownFlashsaleDocument, options);
        }
export function useProductDetailCountdownFlashsaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>(ProductDetailCountdownFlashsaleDocument, options);
        }
export type ProductDetailCountdownFlashsaleQueryHookResult = ReturnType<typeof useProductDetailCountdownFlashsaleQuery>;
export type ProductDetailCountdownFlashsaleLazyQueryHookResult = ReturnType<typeof useProductDetailCountdownFlashsaleLazyQuery>;
export type ProductDetailCountdownFlashsaleSuspenseQueryHookResult = ReturnType<typeof useProductDetailCountdownFlashsaleSuspenseQuery>;
export type ProductDetailCountdownFlashsaleQueryResult = Apollo.QueryResult<ProductDetailCountdownFlashsaleQuery, ProductDetailCountdownFlashsaleQueryVariables>;